import { render, staticRenderFns } from "./FinancialReport.vue?vue&type=template&id=4f134abe&scoped=true&"
import script from "./FinancialReport.vue?vue&type=script&lang=js&"
export * from "./FinancialReport.vue?vue&type=script&lang=js&"
import style0 from "./FinancialReport.vue?vue&type=style&index=0&id=4f134abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f134abe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
